import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DataresolverService implements Resolve<any>{

  constructor(public http:HttpClient) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let id=route.paramMap.get('id');
    let id2=route.paramMap.get('id2');
    return this.http.get('$id/$id2');
   // throw new Error('Method not implemented.');
  }
}
